export default __webpack_public_path__ + "static/media/notion-alert-circle.a83f4aae.svg";